import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, Subject, of, takeUntil } from "rxjs";
// Models
import { CebeProcedureViewModel } from "src/app/_core/models/centros/cebe-procedure.model";
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";
import { UserProfileViewModel } from "src/app/_core/models/main/user-profile.model";
import { UserProfileStore } from "src/app/_core/stores/user-profile.store";

// Services
import { FormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TagViewModel } from "src/app/_core/models/home/tag.model";
import { CebesService } from "src/app/_core/providers/cebes.service";
import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";
import { LoaderService } from "src/app/_core/providers/loader.service";
import { getHomeMenuWithVisited } from "src/app/_core/constants/menu.constants";

@Component({
	selector: "app-home",
	templateUrl: "./home.page.html",
	styleUrls: ["./home.page.scss"],
})
export class HomeComponent implements OnInit {
	// Constants
	private readonly TAG_TYPE_DEPARTMENT = "DEPARTMENT";
	private readonly TAG_TYPE_COUNTRY = "COUNTRY";
	private readonly TAG_TYPE_PROJECT_TYPE = "PROJECT_TYPE";

	constructor(
		private readonly _titleService: Title,
		private readonly _translateService: TranslateService,
		private readonly _userProfileStore: UserProfileStore,
		private readonly _globalService: GlobalService,
		private readonly _loaderService: LoaderService,
		private readonly _cebesService: CebesService
	) {
		const miga: MigaDePan[] = [
			{
				nombre: "header.menu.home.home",
				url: window.location.href,
			},
		];
		this._globalService.limpiarMigas();
		this._globalService.actualizarMigas(miga);
	}

	// Main
	private readonly destroy$ = new Subject<void>();
	public contextLocation: ContextLocationViewModel;
	private readonly menu: LinkItem[] = getHomeMenuWithVisited("/home");

	// Properties

	public userProfile: UserProfileViewModel;
	public departments: Array<any>;
	public countries: Array<any>;
	public projectTypes: Array<any>;

	public loadGlobe: boolean = false;
	public tagsDepartment: Array<TagViewModel>;
	public tagsCountries: Array<TagViewModel>;
	public tagsProjectType: Array<TagViewModel>;
	public selectedTags: TagViewModel[] = [];
	public selectedTagsDepartment: TagViewModel[] = [];
	public selectedTagsCountry: TagViewModel[] = [];
	public selectedTagsProyectType: TagViewModel[] = [];
	public selectedTag: TagViewModel | null;

	public filterFavouriteServices: boolean = false;
	public displayFilters: boolean = false;
	public allServices: CebeProcedureViewModel[] = [];
	public filteredServices: CebeProcedureViewModel[] = [];
	public pageSize = 8;
	public page = 1;
	public reportConfig: any;

	public embedConfig: any;

	// Forms
	departmentForm = new FormControl("");
	countryForm = new FormControl("");
	projectTypeForm = new FormControl("");

	// Events
	ngOnInit(): void {
		this._globalService.setHeaderOptions(
			[],
			this.contextLocation,
			[],
			this.menu
		);

		this._titleService.setTitle(
			this._translateService.instant("title.home")
		);
		this._loaderService.start();

		this.contextLocation = {
			country: "",
			countryName: "",
			cebe: 0,
			serviceName: "",
			centro: 0,
			siteName: "",
		};

		this.userProfile = this._userProfileStore.getUserProfile();

		this._loadData();
	}

	// Public methods
	toggleFilters() {
		this.displayFilters = !this.displayFilters;

		if (this.displayFilters == true) {
			this._loadSelectores();
			this._refreshFilter();
		} else {
			this.departmentForm.reset();
			this.countryForm.reset();
			this.projectTypeForm.reset();
		}
	}

	departmentSelectionChanged(event) {
		let newTags: string[] = [];

		if (event && event.value && event.value.length > 0) {
			newTags = event.value;
		}

		this._refreshTagList(newTags, this.TAG_TYPE_DEPARTMENT);
	}

	countrySelectionChanged(event) {
		let newTags: string[] = [];

		if (event && event.value && event.value.length > 0) {
			newTags = event.value;
		}

		this._refreshTagList(newTags, this.TAG_TYPE_COUNTRY);
	}

	projectTypeSelectionChanged(event) {
		let newTags: string[] = [];

		if (event && event.value && event.value.length > 0) {
			newTags = event.value;
		}

		this._refreshTagList(newTags, this.TAG_TYPE_PROJECT_TYPE);
	}

	favCebe(cebe: string) {
		this._refreshFilter();
	}

	unfavCebe(cebe: string) {
		this._refreshFilter();
	}

	loadMore() {
		this.page++;
	}

	getTagName(tag: TagViewModel) {
		switch (tag.tagType) {
			case this.TAG_TYPE_DEPARTMENT:
				return `departments.${  tag.tag}`;
			case this.TAG_TYPE_COUNTRY:
				return `countries.${  tag.tag}`;
			case this.TAG_TYPE_PROJECT_TYPE:
				return tag.tag;
			default:
				return tag.tag;
		}
	}

	toggleFavouritesServices() {
		this.filterFavouriteServices = !this.filterFavouriteServices;
		this._refreshFilter();
	}

	selectTag(tag) {
		const coincidentTag = this.selectedTags.some(
			(x) => x.tag == tag.tag && x.tagType == tag.tagType
		);

		if (!coincidentTag) {
			switch (tag.tagType) {
				case this.TAG_TYPE_DEPARTMENT:
					this.selectedTagsDepartment.push(tag);
					this.selectedTag = null;
					this._refreshFilter();

					break;
				case this.TAG_TYPE_COUNTRY:
					this.selectedTagsCountry.push(tag);
					this.selectedTag = null;
					this._refreshFilter();

					break;
				case this.TAG_TYPE_PROJECT_TYPE:
					this.selectedTagsProyectType.push(tag);
					this.selectedTag = null;
					this._refreshFilter();

					break;
			}
		}
	}

	removeTag(tag: TagViewModel): void {
		let formControl: FormControl;

		switch (tag.tagType) {
			case this.TAG_TYPE_DEPARTMENT:
				const indexDepartment = this.selectedTagsDepartment.indexOf(
					tag,
					0
				);

				if (indexDepartment > -1) {
					this.selectedTagsDepartment.splice(indexDepartment, 1);
					this._refreshFilter();
				}
				formControl = this.departmentForm;
				break;
			case this.TAG_TYPE_COUNTRY:
				const indexCountry = this.selectedTagsCountry.indexOf(tag, 0);

				if (indexCountry > -1) {
					this.selectedTagsCountry.splice(indexCountry, 1);
					this._refreshFilter();
				}
				formControl = this.countryForm;
				break;
			case this.TAG_TYPE_PROJECT_TYPE:
				const indexProjectType = this.selectedTagsProyectType.indexOf(
					tag,
					0
				);

				if (indexProjectType > -1) {
					this.selectedTagsProyectType.splice(indexProjectType, 1);
					this._refreshFilter();
				}
				formControl = this.projectTypeForm;
				break;
		}

		const formIndex = formControl.value.indexOf(tag.tag);

		if (formIndex > -1) {
			formControl.value.splice(formIndex, 1);
			formControl.setValue(formControl.value);
		}
	}

	// Private methods
	private _loadData() {
		this._loadCebes().subscribe(() => {
			this._loaderService.end();
		});
	}

	_loadSelectores(): void {
		this._loadDepartments();
		this._loadProjectTypes();
		this._loadCountries();
		this._loadTags();
	}

	private _loadCebes(): Observable<any> {
		const result = this._cebesService.getCebes();

		result
			.pipe(takeUntil(this.destroy$))
			.subscribe((cebes: Array<CebeProcedureViewModel>) => {
				this.allServices = cebes.sort((x, y) =>
					x.actividad > y.actividad ? 1 : -1
				);

				this.allServices.map((service) => {
					service.tags = [
						{
							tag: service.codigoActividad,
							tagType: this.TAG_TYPE_DEPARTMENT,
						} as TagViewModel,
						{
							tag: service.codigoIso2Pais,
							tagType: this.TAG_TYPE_COUNTRY,
						} as TagViewModel,
						{
							tag: service.codigoTipoProyecto,
							tagType: this.TAG_TYPE_PROJECT_TYPE,
						} as TagViewModel,
					];
				});

				this.filteredServices = cebes;

				setTimeout(() => {
					this.loadGlobe = true;
				}, 500);

				return cebes;
			});

		return result;
	}

	private _loadDepartments(): Observable<any> {
		const uniqueDepartments: string[] = Array.from(
			new Set(
				this.allServices
					.filter((cebe) => cebe.codigoActividad != null)
					.map((cebe) => cebe.codigoActividad)
					.sort()
			)
		);

		this.departments = uniqueDepartments;

		return of(uniqueDepartments);
	}

	private _loadProjectTypes(): Observable<any> {
		const uniqueProjectTypes: string[] = Array.from(
			new Set(
				this.allServices
					.filter((cebe) => cebe.codigoTipoProyecto != null)
					.map((cebe) => cebe.codigoTipoProyecto)
					.sort()
			)
		);

		this.projectTypes = uniqueProjectTypes;

		return of(uniqueProjectTypes);
	}

	private _loadCountries(): Observable<any> {
		const uniqueCountries: string[] = Array.from(
			new Set(
				this.allServices
					.filter((cebe) => cebe.codigoIso2Pais != null)
					.map((cebe) => cebe.codigoIso2Pais)
					.sort()
			)
		);

		this.countries = uniqueCountries;

		return of(uniqueCountries);
	}

	private _loadTags(): any {
		const result = [];

		this.tagsDepartment = this.departments
			.map((y: any) => {
				return {
					tag: y,
					tagType: this.TAG_TYPE_DEPARTMENT,
				} as TagViewModel;
			})
			.sort((x, y) => (x.tag > y.tag ? 1 : -1));

		this.tagsCountries = this.countries
			.map((y: any) => {
				return {
					tag: y,
					tagType: this.TAG_TYPE_COUNTRY,
				} as TagViewModel;
			})
			.sort((x, y) => (x.tag > y.tag ? 1 : -1));

		this.tagsProjectType = this.projectTypes
			.map((y: any) => {
				return {
					tag: y,
					tagType: this.TAG_TYPE_PROJECT_TYPE,
				} as TagViewModel;
			})
			.sort((x, y) => (x.tag > y.tag ? 1 : -1));

		return result;
	}

	private _refreshTagList(newSelection: string[], tagType: string) {
		const newTags: TagViewModel[] = newSelection.map((x) => {
			const result: TagViewModel = {
				tag: x,
				tagType,
			};
			return result;
		});

		switch (tagType) {
			case this.TAG_TYPE_DEPARTMENT:
				this.selectedTagsDepartment = newTags;
				break;

			case this.TAG_TYPE_COUNTRY:
				this.selectedTagsCountry = newTags;
				break;

			case this.TAG_TYPE_PROJECT_TYPE:
				this.selectedTagsProyectType = newTags;
				break;

			default:
				newTags.forEach((x) => this.selectedTags.push(x));
				break;
		}

		this._refreshFilter();
	}

	private _refreshFilter() {
		this.filteredServices = [];

		this.filteredServices = this.allServices.filter((service) => {
			return (
				(this.selectedTagsDepartment.some(
					(tag) => tag.tag == service.codigoActividad
				) ||
					this.selectedTagsDepartment.length == 0) &&
				(this.selectedTagsCountry.some(
					(tag) => tag.tag == service.codigoIso2Pais
				) ||
					this.selectedTagsCountry.length == 0) &&
				(this.selectedTagsProyectType.some(
					(tag) => tag.tag == service.codigoTipoProyecto
				) ||
					this.selectedTagsProyectType.length == 0)
			);
		});
		// }

		if (this.filterFavouriteServices) {
			this.filteredServices = this.filteredServices.filter(
				(x) => x.isFav
			);
		}
	}
}
